import { render, staticRenderFns } from "./BaseFileInput.vue?vue&type=template&id=043adeca&scoped=true&"
import script from "./BaseFileInput.vue?vue&type=script&lang=js&"
export * from "./BaseFileInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileInput.vue?vue&type=style&index=0&id=043adeca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043adeca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
